import { createContext } from 'react';
import { FieldApi, FieldState } from 'informed';

export interface TySelectContextValue<T=any> {
  tySelectApi: FieldApi<T>;
  tySelectState: FieldState<T>;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const TySelectContext = createContext<TySelectContextValue | null>(null);
